import Base from './action-base'
import renderFields from './change-playbook-thumbnail.pug'

export default class ChangePlaybookThumbnail extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-image"

  @DEFAULTS:
    assetId: null

  renderFields: renderFields
